import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { Faq } from './components/Faq';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { initPixel, trackPageView } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen font-sans selection:bg-brand-gold/30 selection:text-brand-navy" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <FailedAttempts data-id="element-4" />
        <Mechanism data-id="element-5" />
        <Deliverables data-id="element-6" />
        <Audience data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <Proof data-id="element-9" />
        <Offer data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Faq data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <PurchaseNotifications data-id="element-14" />
    </div>;
}